import styled from 'styled-components';

export const Page = styled.main`
  min-height: calc(100vh - 132px);
  padding: 28px clamp(18px, 4vw, 64px) 48px;
  background-color: #f0f8ff;
  background-image: radial-gradient(circle at 92% 4%, rgba(40, 150, 246, 0.13), transparent 28%);
`;

export const SetupShell = styled.section`
  max-width: 840px;
  margin: 6vh auto 0;
`;

export const Eyebrow = styled.div`
  margin-bottom: 10px;
  color: #1677ff;
  font-size: 12px;
  font-weight: 750;
  letter-spacing: 0.12em;
  text-transform: uppercase;
`;

export const SetupCard = styled.div`
  margin-top: 26px;
  padding: clamp(24px, 4vw, 38px);
  border: 1px solid rgba(2, 21, 41, 0.08);
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.92);
  box-shadow: 0 24px 60px rgba(2, 21, 41, 0.09);
`;

export const FieldLabel = styled.label`
  display: block;
  margin-bottom: 9px;
  color: #172b4d;
  font-size: 14px;
  font-weight: 700;
`;

export const SetupHint = styled.p`
  margin: 10px 0 0;
  color: #667085;
  font-size: 13px;
  line-height: 1.55;
`;

export const Workspace = styled.section`
  max-width: 1640px;
  margin: 0 auto;
`;

export const Toolbar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  margin-bottom: 18px;
  padding: 15px 18px;
  border: 1px solid rgba(2, 21, 41, 0.08);
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.94);
  box-shadow: 0 8px 24px rgba(2, 21, 41, 0.06);

  @media (max-width: 900px) {
    align-items: stretch;
    flex-direction: column;
  }
`;

export const ToolbarTitle = styled.div`
  min-width: 0;

  strong {
    display: block;
    overflow: hidden;
    color: #101828;
    font-size: 16px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  span {
    display: block;
    margin-top: 3px;
    color: #667085;
    font-size: 12px;
  }
`;

export const ProgressBlock = styled.div`
  min-width: min(340px, 100%);

  .ant-progress {
    margin: 0;
  }
`;

export const FrameMeta = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 12px;
  margin-bottom: 14px;
  color: #475467;
  font-size: 13px;

  strong {
    color: #101828;
  }
`;

export const MetaStatus = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 14px;
  margin-left: auto;

  @media (max-width: 760px) {
    width: 100%;
    margin-left: 0;
  }
`;

export const ReviewComment = styled.div`
  width: min(300px, 100%);
  margin-left: auto;

  .ant-input {
    min-height: 34px;
  }

  [role='alert'] {
    display: block;
    margin-top: 5px;
    color: #ffd666;
    font-size: 12px;
  }

  @media (max-width: 1020px) {
    width: 100%;
    margin-left: 0;
  }
`;

export const PreviewGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;

  @media (max-width: 980px) {
    grid-template-columns: 1fr;
  }
`;

export const PreviewCard = styled.article`
  overflow: hidden;
  border: 1px solid #d8e1ea;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 10px 30px rgba(2, 21, 41, 0.08);
`;

export const PreviewHeading = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 47px;
  padding: 10px 14px;
  border-bottom: 1px solid #e8edf2;
  color: #172b4d;
  font-size: 14px;
  font-weight: 700;
`;

export const ImageStage = styled.div`
  position: relative;
  width: 100%;
  height: clamp(360px, 57vh, 680px);
  overflow: hidden;
  background:
    linear-gradient(45deg, rgba(255, 255, 255, 0.025) 25%, transparent 25%) 0 0 / 20px 20px,
    #050708;
`;

export const PreviewImage = styled.img`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

export const Legend = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
  padding: 12px 14px 14px;
  border-top: 1px solid #e8edf2;
  background: #fbfcfd;
`;

export const LegendItem = styled.span<{ $color: string }>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px;
  border: 1px solid #e2e8f0;
  border-radius: 999px;
  background: #fff;
  color: #344054;
  font-size: 12px;

  &::before {
    width: 9px;
    height: 9px;
    border-radius: 3px;
    background: ${({ $color }) => $color};
    content: '';
  }
`;

export const ActionDock = styled.div`
  position: sticky;
  top: 12px;
  z-index: 12;
  display: grid;
  grid-template-columns: minmax(230px, 1fr) auto minmax(280px, 1fr);
  align-items: center;
  gap: 16px;
  margin-bottom: 18px;
  padding: 13px 16px;
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 14px;
  background: rgba(2, 21, 41, 0.94);
  box-shadow: 0 18px 48px rgba(2, 21, 41, 0.24);
  backdrop-filter: blur(12px);

  > :nth-child(2) {
    justify-self: center;
  }

  > :last-child {
    justify-self: end;
  }

  @media (max-width: 1020px) {
    display: flex;
    align-items: stretch;
    flex-direction: column;

    > :nth-child(2),
    > :last-child {
      justify-self: auto;
    }
  }
`;

export const ActionGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;

  .ant-btn {
    min-width: 112px;
    font-weight: 650;
  }

  kbd {
    margin-left: 7px;
    padding: 1px 5px;
    border: 1px solid currentColor;
    border-radius: 4px;
    font-family: inherit;
    font-size: 10px;
    opacity: 0.65;
  }
`;

export const Timer = styled.div`
  color: #667085;
  font-size: 12px;
  white-space: nowrap;

  strong {
    margin-left: 5px;
    color: #101828;
    font-variant-numeric: tabular-nums;
  }
`;

export const SummaryCard = styled.div`
  overflow: hidden;
  border: 1px solid rgba(2, 21, 41, 0.08);
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 14px 36px rgba(2, 21, 41, 0.08);
`;

export const SummaryHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
  padding: 24px;
  border-bottom: 1px solid #e8edf2;

  @media (max-width: 760px) {
    flex-direction: column;
  }
`;

export const CacheNotice = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 7px;
  color: #667085;
  font-size: 12px;
`;
